<template>
    <div id="pj_wrap">
        <comheader></comheader>
        <div class="lf ks_right" id="rmodel">
        <comtop></comtop>
        <h2>权限管理<b>></b></h2>
        <div class="pj_cread" >
          <ul>
            <li class="pjcread_on"><img src="/static/img/hbm.png">
            <router-link :to="{name:'bmgl'}">
                   部门/人员管理列表               
            </router-link>  
            </li>
            <li ><img src="/static/img/hgl.png">
            <router-link :to="{name:'manager',query: {view:'js'}}">
                   管理员/角色权限               
            </router-link>  </li>
          </ul>
        </div>
      <div class="pj_dh">
        <div class="zt_title" v-if="pjview">
            <span class="zt_on">内部</span> 
            <!-- <em></em>
            <span>外部</span> -->
        </div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="pj_dhhref" v-if="pjbred"  >
          <el-breadcrumb-item  @click="pjhead"><span @click="pjhead">内部</span></el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item,i) in pjlist" :key="i" ><span @click="pjrlist(item.id,i)">{{item.name}}</span></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      
      <div class="clear"></div>
       <div class="js_list">
        <ul>
            <li v-for="(item,index) in listpeo" :key="index" :data-id="item.sec_id" @click="nextpeo(item.sec_id,item.sec_name)"> 
                <div class="js_hname lf">
                    <img src='/static/img/peop.png'>
                    <span>{{item.sec_name?item.sec_name:item.nickname}}</span>
                </div>
            </li>
        </ul>
      </div>
      </div>
    </div>
</template>

<script>

import comheader from '../Common/comheader'
import comtop from '../Common/comtop'
export default {
  name: 'bmgl',
  inject:["reload"],
  data(){
      return{
        listpeo:[],
        listuser:[],
        listedit:[],
        pjbred:false,
        pjview:true,
        listimg:[],
        pjlist:[],
        checkid:[],
        modeldel:false,
        modeloa:false,
        part:'',
        modeluser:false,
        edit:false,
        show: false,
        title:'',
        id:'',
        temp:true,
        len:'',
        username:'',
        eid:'',
        nrtitle:'',
        jsname:'',
        dataid:'',
        delid:'',
        listpeo:[
          {user_id:'666',name:'123',pic:''}
        ],
        partid:'',
        userquery:this.$route.query.view,
      }
  }, 
  components:{
    comheader,
    comtop,
  },
  methods:{
    nextpeo(id,name){
      if(id===undefined){
        return false
      }
      this.pjlist.push({name:name,id:id})
      var list=[],
          data={
            service:'Examtask.Adminson',
            id:id
          };
      this.$axios.post(this.HOME,this.$qs.stringify(data))
      .then(res => {
        for(let n in res.data.data)
        {
          list.push(res.data.data[n])
        }
        this.listpeo =list
        this.pjbred=true
        this.pjview=false
      })
      .catch(function (error) { // 请求失败处理
      });
    },
    pjhead(){
      var data ={
      service:'Examtask.Admininfo'
    }
    var list =[]
    this.$axios.post(this.HOME,this.$qs.stringify(data))
      .then(res => {
        for(let n in res.data.data)
        {
          list.push(res.data.data[n])
        }
        this.listpeo =list
        this.pjlist=[]
        this.pjbred=false
        this.pjview=true
      })
      .catch(function (error) { // 请求失败处理
      });
    },
    pjrlist(id,i){
      var data ={
      service:'Examtask.Adminson',
      id:id
    }
    var list =[]
    this.$axios.post(this.HOME,this.$qs.stringify(data))
      .then(res => {
        for(let n in res.data.data)
        {
          list.push(res.data.data[n])
        }
        this.listpeo =list
        this.pjlist.splice(i+1)
      })
      .catch(function (error) { // 请求失败处理
      });
    }
  },
  mounted(){
    var data ={
      service:'Examtask.Admininfo'
    }
    var list =[]
    this.$axios.post(this.HOME,this.$qs.stringify(data))
      .then(res => {
        for(let n in res.data.data)
        {
          list.push(res.data.data[n])
        }
        this.listpeo =list
        console.log(list)
      })
      .catch(function (error) { // 请求失败处理
      });
  }

}
</script>
<style>
@import "../../assets/css/manager.css";
</style>
 


// WEBPACK FOOTER //
// src/components/manager/bmgl.vue